function slugify(input) {
	if (!input) return '';

	// make lower case and trim
	var slug = input.toLowerCase().trim();

	// remove accents from charaters
	slug = slug.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

	// replace invalid chars with spaces
	slug = slug.replace(/[^a-z0-9\s-]/g, ' ').trim();

	// replace multiple spaces or hyphens with a single hyphen
	slug = slug.replace(/[\s-]+/g, '-');

	return slug;
}

export const autoSizeColumns = (columns, rows, options = {}) => {
	const defaultPadding = options.padding ?? 40;
	const avgCharWidth = options.charWidth ?? 7.5;

	return columns.map((col) => {
		if (col.field === 'id' || col.disableAutoWidth) return col; // skip if needed

		const longestValue = rows.reduce((max, row) => {
			const value = row[col.field]?.toString() || '';
			return value.length > max.length ? value : max;
		}, '');

		const calculatedWidth = longestValue.length * avgCharWidth + defaultPadding;

		return {
			...col,
			minWidth: Math.max(calculatedWidth, col.minWidth || 100), // respect minWidth
		};
	});
}
